module.exports = {"450327100":"灌阳镇","450327101":"黄关镇","450327102":"文市镇","450327103":"新街镇","450327104":"新圩镇","450327105":"水车镇","450327200":"洞井瑶族乡","450327201":"观音阁乡","450327202":"西山瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450327.json
// module id = 2103
// module chunks = 0